import { ProductTypes } from 'products-data';
import { STANDARD_ITEM_RESULT_VIEW_COMPONENTS } from './standard/component-providers/tokens';
import { WIRE_CUT_ITEM_RESULT_VIEW_COMPONENTS } from './wire-cut/component-provider/tokens';

export const ITEM_RESULT_VIEW_COMPONENT_TOKENS = {
  [ProductTypes.Standard]: STANDARD_ITEM_RESULT_VIEW_COMPONENTS,
  [ProductTypes.Wire]: WIRE_CUT_ITEM_RESULT_VIEW_COMPONENTS,
};
